import { Navbar } from '../../components/feature/Navbar';
import { PageHero } from '../../components/feature/PageHero';
import { TrustBar } from '../../components/feature/TrustBar';
import { AboutContent } from './components/AboutContent';
import { AIAnswerBlock } from '../../components/feature/AIAnswerBlock';
import { MidCTABanner } from '../../components/feature/MidCTABanner';
import { Process } from '../home/components/Process';
import { WhyChooseUs } from '../home/components/WhyChooseUs';
import { ServiceAreas } from '../../components/feature/ServiceAreas';
import { Testimonials } from '../home/components/Testimonials';
import { FAQ } from '../../components/feature/FAQ';
import { QuoteForm } from '../home/components/QuoteForm';
import { Footer } from '../../components/feature/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <PageHero
        title="Your Local Signage Partner"
        titleHighlight="Since Day One"
        subtitle="Locally owned. Globally backed. Signarama Arlington brings 40+ years of world-class signage expertise to every business in the DFW Metroplex."
        backgroundImage="https://cdn.gorilladash.com/static/clients/signarama/images/backgroundbanner.png?format=pjpg&auto=webp&quality=85&fit=cover&width=1920&height=1080"
        primaryCTA="Meet Our Team"
        secondaryCTA="Our Services"
        secondaryCTAHref="/services"
        badge="Locally Owned — Arlington, TX Franchise"
      />
      <TrustBar />
      <AboutContent />
      <AIAnswerBlock context="about" />
      <MidCTABanner />
      <Process />
      <WhyChooseUs />
      <ServiceAreas />
      <Testimonials />
      <FAQ context="about" />
      <QuoteForm />
      <Footer />
    </div>
  );
}
